import UsersList from "@/components/users/users-list"

export default function EmployeesPage() {
    return <>
        <UsersList />
    </>
}
